import { useState, useEffect } from 'react';
import { loadActual, parseActual, loadEvent, getStateInfo, getDangerLevelInfo, round, getDangersList, getMchsList, ShowLocaleDateTime } from '../../helpers/helpers'

import { Radio, Checkbox, Table, Tag, Space, DatePicker, Button, Select, AutoComplete, Popover, Input } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import locale from 'antd/es/date-picker/locale/ru_RU';
import dayjs from 'dayjs';

import References from '../../helpers/Reference';
import { useNavigate } from 'react-router-dom';

const FILTER_BLOCK_HEIGHT = 150;
const TABLE_PADDING_SIZE = 220;

	const dangerOptions = getDangersList();		

const escaladeOptions = [
	{label: References.dictionary.all, value: 0},
	{label: References.dictionary.escalade, value: 1},
	{label: References.dictionary.deescalade, value: 2},
];

const defEscaladeOption = 0;

export const Event = () => {

    const now = new Date().getTime() + 1000 * 3600 * 2;
    const prev = now - 1000 * 60 * 60 * 24;    

	const [ loaded, setLoaded ] = useState(false);
	const [ loadingTable, setLoadingTable ] = useState( false );
	const [ events, setEvents ] = useState( [] );
	const [ showEvents, setShowEvents ] = useState( [] );

    const [ start, setStart ] = useState( new Date(prev).toLocaleString(References.locale) );
    const [ finish, setFinish ] = useState( new Date(now).toLocaleString(References.locale) );

    const [ selectedDangers, setSelectedDangers ] = useState([]);
    const [ selectedMchsTypes, setSelectedMchsTypes ] = useState([]);

    const [ stationsOptions, setStationsOptions ] = useState([]);
    const [ foundedStationsOptions, setFoundedStationsOptions] = useState([]);
    const [ selectedStation, setSelectedStation ] = useState({
    	label: "",
    	value: ""
    });

	const [ mchsTypesOptions, setMchsTypesOptions] = useState([]);
	const [ filterNODATA ,setFilterNODATA] = useState( false );
	const [ filterEscalade, setFilterEscalade ] = useState( defEscaladeOption )
	const [ expired, setExpired ] = useState(false);
	const [ searchTerm, setSearchTerm ] = useState("");

	const navigate = useNavigate();	

	useEffect(() => {
		loadEvent( {start, finish} )
			.then(data => {
				setLoaded( true );
				if (data.hasOwnProperty('events')) {
					setEvents( data.events );
					setShowEvents( data.events );
				}
			});
		loadActual()
			.then(data => {
				const parse = parseActual(data);
				setStationsOptions(parse);
				setMchsTypesOptions(getMchsList(parse));					
			});			

	}, []);

	const onStartOk = ( value ) => {
		setExpired(true);
		setStart( new Date(value.$y, value.$M, value.$D, value.$H).toLocaleString(References.locale))
	}

	const onFinishOk = ( value ) => {
		setExpired(true);
		setFinish( new Date(value.$y, value.$M, value.$D, value.$H).toLocaleString(References.locale))		
	}

	const onShowEVentFilter = () => {
		setLoadingTable( true );
		setSearchTerm(null);
		const stationValue = selectedStation.value;
		loadEvent( {start, finish, selectedDangers, selectedMchsTypes, stationValue, filterNODATA, filterEscalade} )
			.then(data => {
				setLoadingTable( false );
				setExpired(false);
				if (data.hasOwnProperty('events')) {
					setEvents( data.events );
					setShowEvents( data.events );
				}
			});
	}

	const onSelectDangers = (value) => {
		setExpired(true)
		setSelectedDangers(value);
	} 
	
	const onSelectMchsTypes = (value) => {
		setExpired(true);
		setSelectedMchsTypes(value)
	}

	const onStationClick = ( e, stationUUID ) => {
		e.preventDefault();
		localStorage.setItem('show_station', stationUUID);
		navigate('/', { replace: true });
	}

	const onStationChange = ( e ) => {		
		const term = e.target.value;
		setSearchTerm(term);

		const currEvents =  events;
		const filteredEvents = currEvents.filter((item) => 
			item?.station?.short_name.indexOf(term) > -1
		)
		setShowEvents(filteredEvents);
	}

	const onStationSearch = (value) => {
		setFoundedStationsOptions(() => {
			let founded = [];
			if ( !value )
				founded = stationsOptions;
			else {
				founded = stationsOptions.filter(item => {
					return item.name.indexOf(value) != -1
				});
			}
			return founded.map((item) => ({
				label: item.name,
				value: item.uuid
			}));
		});
	}

	const onStationSearchSelect	= ( data, option ) => {		
		setExpired(true)
		setSelectedStation( option );
	}

	const onChangeFilterNODATA = ( e ) => {
		setExpired(true)
		setFilterNODATA( e.target.checked );
	}

	const onChangeFilterEscalade = ( e ) => {
		setExpired(true)
		setFilterEscalade( e.target.value );
	}

	const getValue = ( value, mchsType ) => {
		if (value) {
			if (References.mchs.hasOwnProperty(mchsType)) {
				let mchsInfo = References.mchs[mchsType];
				if (value.hasOwnProperty(mchsInfo.field))
					return round( value[mchsInfo.field], mchsInfo.precision );
			}
		}
	}

    const eventsData = showEvents.map((item, index) => {

    	let stateStart = getStateInfo(item.state_code_from, item.mchs.type);
    	let stateFinish = getStateInfo(item.state_code_to, item.mchs.type);
    	let dangerInfo = getDangerLevelInfo(item.danger_level_code);

        return {
			key: 'events_table_row' + index,
            station_uuid: item.station.uuid,
			station_short_name: item.station.short_name, 
			mchs_uuid: item.mchs.uuid,
			mchs_type: item.mchs.type,
			mchs_name: item.mchs.name,
			danger_level: dangerInfo,
			state_start_short: stateStart['short'],
			start_start_full: stateStart['title'],
			state_finish_short: stateFinish['short'],
			state_finish_full: stateFinish['title'],
			danger_level_short: dangerInfo['short'],
			danger_level_full: dangerInfo['title'],
			value: getValue( item.value, item.mchs.type ),
			state_change_date: ShowLocaleDateTime(item.time)
        };
    })

	const columns = [
	    {
	        title: 'Пост',
	        dataIndex: 'station_short_name',
	        key: 'event_table_header_station',
			render: (text, record) => {
				return <a href={`${record.station_uuid}&description`} onClick={(e) => onStationClick(e, record.station_uuid)}>{text}</a>;
			}
	    },

	    {
	        title: 'Канал',
	        dataIndex: 'mchs_name',
	        key: 'event_table_header_mchs'
	    },

	    {
	        title: 'Исходное',
	        dataIndex: 'state_start_short',
	        key: 'event_table_header_state_start',
	        render: (text, record) => {
	            return (
	            <Popover
					key={`popup_over_start_${record.station_uuid}_${record.mchs_uuid}`}                              
					placement="topLeft"
					content={record.start_start_full}
					trigger="hover"
				>
					{text}
				</Popover>
	            )
            }

	    },

	    {
	        title: 'Конечное',
	        dataIndex: 'state_finish_short',
	        key: 'event_table_header_state_finish',
	        render: (text, record) => {
	            return (
	            <Popover
					key={`popup_over_finish_${record.station_uuid}_${record.mchs_uuid}`}                              
					placement="topLeft"
					content={record.state_finish_full}
					trigger="hover"
				>
					{text}
				</Popover>
	            )
            }
	    },
	    {
	        title: 'Уровень опасности',
	        dataIndex: 'danger_level_short',
	        key: 'event_table_header_danger',			
	        render: (text, record) => {
	            let color = record.danger_level.color;
	            return (
	            <Popover
					key={`popup_over_danger_${record.station_uuid}_${record.mchs_uuid}`}                              
					placement="topLeft"
					content={record.danger_level_full}
					trigger="hover"

				>
	                    <Tag color={color}>
	                        {text}
	                    </Tag>
				</Popover>
	            )
            }

	    },
	    {
	        title: 'Значение',
	        dataIndex: 'value',
	        key: 'event_table_header_value'
	    },
	    {
	        title: 'Дата/Время',
	        dataIndex: 'state_change_date',
	        key: 'event_table_header_change_date'
	    } 
	]

	return (
	<div>
		{loaded ? (
			<div>
				<div style={{height: FILTER_BLOCK_HEIGHT}}>
					<div className="ml-2 mt-2">					
						<DatePicker
							showTime={{
								format: 'HH:00'
							}}
							defaultValue={dayjs(start, References.dateTimeFormat)}
							format="DD.MM.YYYY HH:00"
							onChange={onStartOk}
							onOk={onStartOk}
							locale={locale}
							changeOnBlur
							inputReadOnly
							allowClear={false}
							style={{width: 200}}
						/>

						<DatePicker
							showTime={{
								format: 'HH:00'
							}}
							defaultValue={dayjs(finish, References.dateTimeFormat)}
							format="DD.MM.YYYY HH:00"
							onChange={onFinishOk}
							onOk={onFinishOk}
							locale={locale}
							changeOnBlur
							inputReadOnly
							allowClear={false}
							className="ml-2"
							style={{width: 200}}
						/>
						<Popover
							placement="bottom"
							content={References.dictionary.event_no_data}
						>
							<Checkbox onChange={onChangeFilterNODATA} className="ml-2">НЕТ ДАННЫХ</Checkbox>
						</Popover>
						<Button className="ml-2" type="default" shape="circle" icon={<ReloadOutlined />} onClick={onShowEVentFilter} />					
					</div>
					<div className="mt-2 ml-2">
						<Select
							mode="tags"
							placeholder="Уровень опасности"
							value={selectedDangers}
							showSearch={false}						
							style={{width:200}}
							allowClear
							onChange={onSelectDangers}
							options={dangerOptions.map(item => {
								return {
									'label': item.short,
									'value': item.code
								}	
							})}							
						/>
						<Select
							mode="tags"
							placeholder="Изм. канал"
							value={selectedMchsTypes}
							showSearch={false}						
							style={{width:200}}
							allowClear						
							className="ml-2"
							onChange={onSelectMchsTypes}
							options={mchsTypesOptions.map(item => {
								return {
									'label': item.name,
									'value': item.code
								}	
							})}							
						/>	                					
						<Radio.Group block options={escaladeOptions} defaultValue={defEscaladeOption} onChange={onChangeFilterEscalade} optionType="button" className="ml-2"/>
					</div>
					<div className="mt-2 ml-2">
						<Input
						style={{
							width: 415,
						}}
						value={searchTerm}
						onChange={onStationChange}
						placeholder="Найти пост"
						allowClear				      
						/>					
					</div>
				</div>
				<div className="pos-relative">
					{loadingTable &&
						<div className="loading loading-elem">&nbsp;</div>
					}

					{expired && 
					<div className="expired-wrapper"></div>
					}

					<Table
						columns={columns}
						dataSource={eventsData}
						pagination={false}
						size="small"
						className="mt-2"
						scroll={{
							y:  "calc(100vh - " + TABLE_PADDING_SIZE + "px)"
						}}
						locale={References.dictionary.table}
	
					/>

				</div>
			</div>
		) : (
			<div id="loading-screen" className="loading">&nbsp;</div>
		)}	
	</div>
	);

}